import { render, staticRenderFns } from "./index.vue?vue&type=template&id=116a5e7b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=116a5e7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116a5e7b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/data/jenkins/workspace/mifos-vue-uat/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib'
installComponents(component, {VSelect})
